import './css/fonts.css';
import './lib/fontawesome-free/css/all.css';
import './css/sb-admin-2.min.css';
import './lib/bootstrap-4.6.2-dist/css/bootstrap.css'
import './css/dataTables.bootstrap4.min.css'

import React, { useState, Suspense } from 'react';
import { ThemeProvider } from 'styled-components';
import { lightTheme } from "./styles/theme";
import GloablStyle from './styles/GlobalStyle';
import GlobalFonts from "./styles/fonts/fonts";
import { Route, HashRouter } from 'react-router-dom'
import { Intro } from './pages';
// import Container from './components/Container'
// import MapContainer from './components/MapContainer'

// const Intro = React.lazy(() => import('./pages/Intro'))
const MudHome = React.lazy(() => import('./pages/MudHome'))
const About = React.lazy(() => import('./pages/About'))

function App() {
  const [theme,] = useState(lightTheme);

  return (
    <ThemeProvider theme={theme}>
      <GloablStyle />
      <GlobalFonts />
      <HashRouter>
        <Route exact path="/" component={Intro} />
        <Suspense fallback={<div>Loading...</div>}>
          <Route path="/home" component={MudHome} />
          <Route path="/about" component={About} />
        </Suspense>
      </HashRouter>


    </ThemeProvider>
  );
}

export default App;
